import script from "./SecondDrop.vue?vue&type=script&lang=ts&setup=true"
export * from "./SecondDrop.vue?vue&type=script&lang=ts&setup=true"

import "./SecondDrop.vue?vue&type=style&index=0&id=142bcb14&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-142bcb14"]])

export default __exports__